import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import QuestionPreview from "../QuestionPreview";
import config from "../../../config/config";

import styles from "./styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((props) => styles(props));

const AnswerContent = (props) => {
  const { t } = useTranslation("surveyTaker");

  const styleTheme = useTheme();
  const styles = useStyles({ ...props, styleTheme });

  const contentBaseUrl = `${config.API_SERVER_URL}`;

  return (
    <div className={styles.questionWrapper}>
      <QuestionPreview
        question={props.question}
        helperText={props.helperText}
      />
      <div className={styles.vidoeAndImageContainer}>
        {props.imagePath && (
          <img
            src={`${contentBaseUrl}${props.imagePath}`}
            width="100%"
            className={styles.imageContentData}
            alt={t("surveyTaker:content")}
          />
        )}
        {props.videoPath && (
          <video
            width="100%"
            src={`${contentBaseUrl}${props.videoPath}`}
            controls
            controlsList="nodownload nofullscreen noremoteplayback"
            className={styles.videoContentData}
            alt={t("surveyTaker:videoContent")}
          />
        )}
        {props.videoLink && (
          <video
            width="100%"
            src={props.videoLink}
            controls
            alt={t("surveyTaker:videoContent")}
          />
        )}
      </div>
    </div>
  );
};

AnswerContent.propTypes = {
  question: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
};

export default AnswerContent;
